import React from 'react';
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

export default function RoleEditorPanel({
  editingRole,
  isNewRole,
  canManageRoles,
  permissionList,
  roleActionPending,
  onFieldChange,
  onPermissionToggle,
  onSaveRole,
  onDeleteRole,
}) {
  return (
    <Paper variant="outlined" sx={{p: 2}}>
      <Typography variant="h6" sx={{mb: 2}}>
        {isNewRole ? 'Neue Rolle anlegen' : 'Rolle bearbeiten'}
      </Typography>
      {editingRole ? (
        <Stack spacing={2}>
          <TextField
            label="Name"
            value={editingRole.name}
            onChange={(e) => onFieldChange('name', e.target.value)}
            disabled={!canManageRoles}
            required
          />
          <TextField
            label="Beschreibung"
            value={editingRole.description}
            onChange={(e) => onFieldChange('description', e.target.value)}
            disabled={!canManageRoles}
            multiline
            minRows={2}
          />
          <Box>
            <Typography variant="subtitle1" sx={{mb: 1}}>
              Berechtigungen
            </Typography>
            <Grid container spacing={1}>
              {permissionList.map((permission) => (
                <Grid item xs={12} sm={6} key={permission.id}>
                  <FormControlLabel
                    control={(
                      <Checkbox
                        checked={editingRole.permissionIds?.includes(permission.id)}
                        onChange={() => onPermissionToggle(permission.id)}
                        disabled={!canManageRoles}
                      />
                    )}
                    label={permission.name}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
          <Stack direction="row" spacing={2}>
            <Button
              variant="contained"
              onClick={onSaveRole}
              disabled={!canManageRoles || roleActionPending || !editingRole.name.trim()}
            >
              {roleActionPending ? 'Speichern…' : 'Speichern'}
            </Button>
            <Button
              variant="outlined"
              color="error"
              onClick={onDeleteRole}
              disabled={isNewRole || !canManageRoles || roleActionPending || editingRole.name.toUpperCase() === 'ADMIN'}
            >
              Löschen
            </Button>
          </Stack>
        </Stack>
      ) : (
        <Typography color="text.secondary">
          Bitte wählen Sie eine Rolle oder legen Sie eine neue an.
        </Typography>
      )}
    </Paper>
  );
}
